// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"72":"be278477","77":"04264d00","296":"4f9b6f5e","376":"66ceb115","599":"713be596","675":"470efa99","808":"f4a59182","833":"7884ab4c"}[chunkId] + ".chunk.js";
};